module.exports = __webpack_public_path__ + "media/剖面--赠送面积.ac035a3a.mp4";